import { queryClient } from "@/config/query";
import storage from "@/utils/storage";
import { Organization } from "@/types/entities";

const useDocumentTitle = () => {
    let organization: Organization | undefined = undefined;

    const oid = storage.getItem("oid");
    if (oid) organization = queryClient.getQueryData<Organization>(["organization", oid]);

    if (!oid && document.title !== "Portal | Dippi") {
        document.title = "Portal | Dippi";
    }
    if (oid && organization && document.title === "Portal | Dippi") {
        document.title = `${organization.title} | Dippi`;
    }
};

export default useDocumentTitle;
